export default __webpack_public_path__ + "static/media/banners-diapadre-coche-checo-330x330.c95492e7.webp";